import axios from 'axios'
import constants from '../constants'

const MENU_GROUPS_PATH = `${constants.urlPrefix}/api/menu/groups`;

export function getMenuGroup(designId) {
    return axios.get(`${MENU_GROUPS_PATH}`, { params: { designId } });
}

export function updateMenuGroup(data, beforeExit) {
    return axios.put(`${MENU_GROUPS_PATH}?beforeExit=${beforeExit || false}`, data);
}

export function syncToSquare(merchantId, designId, data) {
    return axios.post(`${MENU_GROUPS_PATH}/square/${merchantId}/sync?designId=${designId}`, data);
}

export function isMHM(menuGroup) {
    return hasSource(menuGroup, 'mhm');
}

export function isToast(menuGroup) {
    return hasSource(menuGroup, 'toast');
}

export function isSquareGroup(menuGroup) {
    return hasSource(menuGroup, 'square');
}

export function isTreezGroup(menuGroup) {
    return hasSource(menuGroup, 'treez');
}

export function isPopmenuGroup(menuGroup) {
    return hasSource(menuGroup, 'popmenu');
}

export function isItemLibraryGroup(menuGroup) {
    return hasSource(menuGroup, 'itemlibrary');
}

export function isClover(menuGroup) {
    return hasSource(menuGroup, 'clover');
}

function hasSource(menuGroup, source) {
    return menuGroup.source === source || menuGroup.items[0]?.source === source;
}
